import React from 'react'
import styles from '../index.module.scss'
import { Grid } from '@mui/material'
import SelectCustom from '../../atoms/select/SelectCustom'
import InputCustom from '../../atoms/input/InputCustom'

const Officiant = () => {
	return (
		<>
			<div>
				<h3 className={styles.Title}>Officiant Survey</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="companyContactName"
								className={styles.label}
							>
								Contact name
							</label>
							<InputCustom
								id="companyContactName"
								name="companyContactName"
								placeholder="Enter Contact name"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactNumber"
								className={styles.label}
							>
								Contact number
							</label>
							<InputCustom
								id="contactNumber"
								name="contactNumber"
								placeholder="Enter Contact number"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyType"
								className={styles.label}
							>
								Ceremony type
							</label>
							<SelectCustom
								id="ceremonyType"
								name="ceremonyType"
								label="Select"
								options={[
									{
										value: 'civil',
										label: 'Civil / Non-denominational',
									},
									{ value: 'religious', label: 'Religious' },
									{ value: 'cultural', label: 'Cultural' },
									{ value: 'other', label: 'Other' },
								]}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyType"
								className={styles.label}
							>
								Estimated ceremony duration
							</label>
							<InputCustom
								id="ceremonyType"
								name="ceremonyType"
								placeholder="Enter ceremony type"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Details</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="includesReadings"
								className={styles.label}
							>
								Includes readings? (how many?)
							</label>
							<InputCustom
								id="includesReadings"
								name="includesReadings"
								placeholder="Enter readings"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="personalVows"
								className={styles.label}
							>
								Personal vows?
							</label>
							<SelectCustom
								id="personalVows"
								name="personalVows"
								label="Select"
								options={[
									{ value: 'yes', label: 'Yes' },
									{ value: 'no', label: 'No' },
								]}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="religiousElements"
								className={styles.label}
							>
								Religious elements?
							</label>
							<SelectCustom
								id="religiousElements"
								name="religiousElements"
								label="Select"
								options={[
									{ value: 'yes', label: 'Yes' },
									{ value: 'no', label: 'No' },
								]}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="peopleInProcessional"
								className={styles.label}
							>
								Number of people in processional
							</label>
							<InputCustom
								id="peopleInProcessional"
								name="peopleInProcessional"
								placeholder="Enter number of people in processional"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="culturalRequirements"
								className={styles.label}
							>
								Any cultural or timing requirements
							</label>
							<InputCustom
								id="culturalRequirements"
								name="culturalRequirements"
								placeholder="e.g., auspicious hours, prayer breaks, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Timeline</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="arrivalTime"
								className={styles.label}
							>
								Arrival time
							</label>
							<InputCustom
								id="arrivalTime"
								name="arrivalTime"
								placeholder="Enter readings"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rehearsalTime"
								className={styles.label}
							>
								Rehearsal time (if applicable)
							</label>
							<InputCustom
								id="rehearsalTime"
								name="rehearsalTime"
								placeholder="Enter readings"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyTime"
								className={styles.label}
							>
								Start & end time of ceremony
							</label>
							<InputCustom
								id="ceremonyTime"
								name="ceremonyTime"
								placeholder="Enter readings"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="departureTime"
								className={styles.label}
							>
								Post-ceremony duties
							</label>
							<InputCustom
								id="departureTime"
								name="departureTime"
								placeholder="e.g., license signing, announcements, etc."
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
			<div>
				<h3 className={styles.Title}>Other Questions</h3>
				<Grid container spacing={'16px'} sx={{ mt: '16px' }}>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="rainContingency"
								className={styles.label}
							>
								Rain contingency or setup change needed?
							</label>
							<InputCustom
								id="rainContingency"
								name="rainContingency"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="setupDuration"
								className={styles.label}
							>
								Setup / teardown duration
							</label>
							<InputCustom
								id="setupDuration"
								name="setupDuration"
								placeholder="Enter details"
								value=""
								type="time"
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="specialEquipment"
								className={styles.label}
							>
								Special equipment or space needs?
							</label>
							<InputCustom
								id="specialEquipment"
								name="specialEquipment"
								placeholder="Enter details"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="contactForDayOfEmergencies"
								className={styles.label}
							>
								Contact for day-of emergencies
							</label>
							<InputCustom
								id="contactForDayOfEmergencies"
								name="contactForDayOfEmergencies"
								placeholder="Enter contact for day-of emergencies"
								value=""
								onChange={(e) => {}}
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default Officiant
